<template>
    <div class="wizard">
        <div class="row" v-if="step === 1">
            <div class="col-12">
                <p>Вы можете планировать ваш бюджет на конкретный день, указав запланированные расходы или доходы которые выходят базовые планы. Доход которые вы укажете в этот день, повлияет только на последующие дни. Расходы которые будут указаны в любой из дней, уменьшат общую сумму трат в день на следующие дни.</p>
                <ul class="yes-no">
                    <li class="yes-no__item yes-no__item--yes">Укажите незапланированный доход которые вы получите в <strong>этот, конкретный день</strong>.</li>
                    <li class="yes-no__item yes-no__item--yes"><strong>Укажите не запланированные в общий бюджет расходы</strong>: подарок другу, покупка средства мытья посуды, оплата абонемента в спортзал.</li>
                    <li class="yes-no__item yes-no__item--no">Не дублируйте <strong>доходы и расходы которые вы уже указывали</strong> при общем планировании бюджета.</li>
                </ul>
            </div>
            <div class="col-12 border-top mt-2">
                <div class="available-to-budget">
                    <span class="text-muted">Текущие лпаны:</span>
                    <span class="available-to-budget__values">
                        <strong class="available-to-budget__value ">Доход: {{ date.income.value | money }} ₴</strong>
                        <strong class="available-to-budget__value ">Расход: {{ date.outcome.value | money }} ₴</strong>
                    </span>
                </div>
            </div>
            <div class="col-12 border-top pt-3 text-right">
                <button type="button" class="btn btn-outline-secondary mr-2" data-dismiss="modal">{{ $t('Закрыть') }}</button>
                <button type="button" class="btn btn-success" @click="step = 2">Запланировать</button>
            </div>
        </div>
        <div class="row" v-if="step === 2">
            <div class="col-12 border-bottom">
                <div class="wizard-header">
                    <h4>Доход</h4>
                </div>
                <p>Если у вас не запланированн дополнительный доход, вы можете перейти на <a href="#" @click.prevent="step = 3">следующий шаг</a>.</p>
            </div>
            <div class="col-12 mt-3">
                <div class="row">
                    <div class="col-12 mb-2 d-flex outcome-line-tip">
                        <div class="w-75 pl-2">Категория</div>
                        <div class="pl-2">Сумма</div>
                    </div>
                    <div class="col-lg-12 outcome-line" v-for="(category, index) in form.income.categories" :key="index">
                        <div class="input-group">
                            <div class="input-group-prepend w-75">
                                <multiselect v-model="form.income.categories[index].category" :options="availableIncomeCategoriesToSelect" :placeholder="$t('Категория')" label="name" track-by="id"></multiselect>
                            </div>
                            <input type="number" v-model="form.income.categories[index].value" :class="{'form-control': true, 'is-invalid': form.income.categories[index].error === true}" :placeholder="$t('Сумма')">
                            <div class="input-group-append value-currency">
                                <span class="input-group-text" v-html="$options.filters.currency(980)"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-3">
                        <button @click.prevent="addCategoryToIncome" class="btn btn-sm btn-outline-secondary btn-split"><i class="fas fa-plus"></i> <span>Добавить еще</span></button>
                    </div>
                    <div class="col-lg-6 mt-3 justify-content-end d-flex align-items-center">
                        <p class="mb-0">Итого: <strong>{{ incomeSum | money }}</strong> <strong v-html="$options.filters.currency(980)"></strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 border-top pt-3 mt-3 text-right">
                <button type="button" class="btn btn-outline-secondary mr-2" data-dismiss="modal">{{ $t('Отмена') }}</button>
                <button type="button" class="btn btn-success" @click="step = 3">Далее</button>
            </div>
        </div>
        <div class="row" v-if="step === 3">
            <div class="col-12 border-bottom">
                <div class="wizard-header">
                    <h4>Расход</h4>
                </div>
                <p>Укажите плановые расходы которые планируете совершить в этот день. Помните что добавление расходов более лимита на день, уменьшит лимит на последующие дни.</p>
            </div>
            <div class="col-12">
                <div class="available-to-budget">
                    <span class="text-muted">Запланировано:</span>
                    <span class="available-to-budget__values">
                        <strong class="available-to-budget__value ">{{ date.outcome.value | money }} ₴</strong>
                    </span>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-2 d-flex outcome-line-tip">
                        <div class="w-75 pl-2">Категория</div>
                        <div class="pl-2">Сумма</div>
                    </div>
                    <div class="col-lg-12 outcome-line" v-for="(category, index) in form.outcome.categories" :key="index">
                        <div class="input-group">
                            <div class="input-group-prepend w-75">
                                <multiselect v-model="form.outcome.categories[index].category" :options="availableOutcomeCategoriesToSelect" :placeholder="$t('Категория')" label="name" track-by="id"></multiselect>
                            </div>
                            <input type="number" v-model="form.outcome.categories[index].value" :class="{'form-control': true, 'is-invalid': form.outcome.categories[index].error === true}" :placeholder="$t('Сумма')">
                            <div class="input-group-append value-currency">
                                <span class="input-group-text" v-html="$options.filters.currency(980)"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-3">
                        <button @click.prevent="addCategoryToOutcome" class="btn btn-sm btn-outline-secondary btn-split"><i class="fas fa-plus"></i> <span>Добавить еще</span></button>
                    </div>
                    <div class="col-lg-6 mt-3 justify-content-end d-flex align-items-center">
                        <p class="mb-0">Итого: <strong>{{ outcomeSum | money }}</strong> <strong v-html="$options.filters.currency(980)"></strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 border-top pt-3 mt-3 text-right">
                <button type="button" class="btn btn-outline-secondary mr-2" @click.prevent="step = 2">{{ $t('Назад') }}</button>
                <button type="button" class="btn btn-success" @click="step = 4">Далее</button>
            </div>
        </div>
        <div class="row" v-if="step == 4">
            <div class="col-12">
                <h4>Ваш бюджет на {{ date.date }}:</h4>
            </div>
            <div class="col-12 d-flex justify-content-center align-items-center">
                <div class="outcome-total">
                    {{ outcomeSum | money }} 
                    <span class="currency" v-html="$options.filters.currency(980)"></span>
                </div>
            </div>
            <div class="col-12">
                <p>Изменение суммы расходов на сегодня повлияет на сумму расходов в последующие дни. Если вы не выполните план расходов на этот день, то остаток будет пересчитан на последующие дни.</p>
                <p>Указанный доход за этот день, будет добавлен к общей сумме в последующие дни.</p>
            </div>
            <div class="col-12 border-top pt-3 text-right">
                <button type="button" class="btn btn-outline-secondary mr-2" @click.prevent="step = 3">{{ $t('Назад') }}</button>
                <button type="button" class="btn btn-success" @click="store">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: "BudgetDayWizrd",

    props: ['date'],

    data: function() {
        return {
            step: 1,

            form: {},

            errors: {},
        };
    },
    
    watch: {
        'date': function() {
            this.initWizard();
        },
    },
    
    mounted() {
        this.initWizard();

        this.loadCategories();
    },

    computed: {
        ...mapGetters(['categories', 'transactions']),

        availableOutcomeCategoriesToSelect() {
            return this.categories.filter((category) => {
                return ! this.form.outcome.categories.find((item) => item.category && item.category.id === category.id && category.expenses);
            });
        },

        availableIncomeCategoriesToSelect() {
            return this.categories.filter((category) => {
                return ! this.form.outcome.categories.find((item) => item.category && item.category.id === category.id && category.incomes);
            });
        },

        outcomeSum() {
            let amount = 0;

            for(let i = 0; i < this.form.outcome.categories.length; i++) {
                amount += this.form.outcome.categories[i].value;
            }

            return amount;
        },

        incomeSum() {
            let amount = 0;

            for(let i = 0; i < this.form.income.categories.length; i++) {
                amount += this.form.income.categories[i].value;
            }

            return amount;
        },
    },

    methods: {
        ...mapActions(['loadCategories']),

        initWizard() {
            this.step = 1;

            this.form = {
                outcome: {
                    value: 0,
                    categories: [],
                },
                income: {
                    value: 0,
                    categories: [],
                },
                comment: null,
            };

            this.addCategoryToOutcome();
            this.addCategoryToOutcome();
            this.addCategoryToOutcome();

            this.addCategoryToIncome();
            this.addCategoryToIncome();
            this.addCategoryToIncome();
        },

        store() {
            axios.post('/budget/days', Object.assign(this.form, {
                date: this.date.date,
            }))
                .then(({data}) => {
                    this.loadDayInfo();
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        addCategoryToOutcome() {
            this.form.outcome.categories.push({
                category: null,
                value: 0,
                error: false,
            });
        },

        addCategoryToIncome() {
            this.form.income.categories.push({
                category: null,
                value: 0,
                error: false,
            });
        },
    },
}
</script>

<style lang="scss">
.wizard {
    .wizard-header {
        h3 {
            //
        }
    }

    .outcome-total {
        font-size: 100px;
        font-weight: bold;
        white-space: nowrap;
        text-align: center;
    }

    .yes-no {
        list-style-type: none;
        margin: 0 0 2em;
        color: #4c4c4c;
        max-width: 42em;
        font-size: 14px;
        padding-left: 0;
        margin: 0;

        .yes-no__item {
            position: relative;
            padding-left: 20px;
            margin-bottom: 5px;

            &:before {
                content: "";
                position: absolute;
                width: 16px;
                height: 16px;
                left: 1px;
                top: 3px;
            }

            &.yes-no__item--yes:before {
                background: url("../../assets/images/bullet-check.svg") no-repeat 0 0;
            }

            &.yes-no__item--no:before {
                background: url("../../assets/images/bullet-cross.svg") no-repeat 0 0;
            }
        }
    }

    .available-to-budget {
        margin: 15px 0;

        .available-to-budget__values {
            display: block;
            font-size: 16px;

            .available-to-budget__value {
                display: inline-block;
                width: 100%;
            } 
        }
    }

    .multiselect {
        min-height: auto;

        .multiselect__tags {
            min-height: auto;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            border-color: #ced4da;

            .multiselect__placeholder {
                margin-bottom: 5px;
                padding: 1px 0;
            }
        }

        .multiselect__content-wrapper {
            //
        }
    }

    .outcome-line-tip {
        font-size: 12px;
    }

    .outcome-line {
        &:nth-child(2) {
            .multiselect {
                .multiselect__tags {
                    border-top-left-radius: 3px;
                }
            }

            .value-currency {
                .input-group-text {
                    border-top-right-radius: 3px!important;
                }
            }
        }

        .multiselect {
            .multiselect__tags {
                border-bottom-width: 0;
            }
        }

        .form-control {
            border-bottom-width: 0;
        }

        .value-currency {
            .input-group-text {
                border-bottom-width: 0;
            }
        }

        &:nth-last-child(3) {
            .multiselect {
                .multiselect__tags {
                    border-bottom-left-radius: 3px;
                    border-bottom-width: 1px;
                }
            }

            .form-control {
                border-bottom-width: 1px;
            }

            .value-currency {
                .input-group-text {
                    border-bottom-width: 1px;
                    border-bottom-right-radius: 3px!important;
                }
            }
        }
    }
}

</style>